import { CompanyImage, getSession, Image, React, setSidebarIcons, SidebarAction,
         Style, Tooltip, useEffect, useRouter, useState, REDIRECT,
         useNavbarStatus, useUser, SubSidebar, COMMON, ArrowLeft, useTranslation } from '@/imports-files/components/sidebar';
import { CommonAction } from "@/actions/common/common";
import { css } from "styled-components"

export function Sidebar(props)
{
  const router                                      =   useRouter();
  const { t } = useTranslation();
  const sidebarAction                               =   new SidebarAction(router, t);
  const commonAction                                =   new CommonAction();
  // const options                                     =   sidebarAction.getSidebarOptions(props);
  const [options, setOptions]                       =   useState('');
  const [userName, setUserName]                     =   useState('...');
  const [userType, setUserType]                     =   useState('');
  const [userRole, setUserRole]                     =   useState('');
  const [isLoading, setLoaderStatus]                =   useState(true);
  const [session, setSession]                       =   useState(props.session);
  const { user, clearUser, updateUser }             =   useUser();
  const { navbarStatus, updateNavbarStatus }        =   useNavbarStatus();
  const [flagForRerender, setFlagForRerender]       =   useState(0);
  const [currentKeySelected, setCurrentKeySelected] =   useState(JSON.parse(localStorage.getItem('navbarStatus')).key);
  const { i18n } = useTranslation();

  useEffect(() => {
                    if(navbarStatus != undefined && typeof window !== 'undefined')
                    {
                      (async () => {
                                        // let session = await getSession();
                                        // session.role = sidebarAction.setUserRole(session);
                                        // setSession(session);
                                        // setUserName(session?.name);
                                        // setUserType(session?.type);
                                        setOptions(sidebarAction.getSidebarOptions(props));
                                        setUserRole(sidebarAction.setUserRole(session));

                                        // if(!user?.user_image && session?.photo_url){
                                          var profileData = await sidebarAction.getProfilePhotoUrl(session)
                                          var base64Data = await commonAction.convertUrlToBase64(profileData.photo_url);
                                          if (user?.language_iso_code && (user?.language_iso_code != profileData.language_iso_code)) {
                                            i18n.changeLanguage(profileData.language_iso_code)
                                          }
                                          await updateUser({user_image: base64Data, user_name: profileData?.name, user_id: session?.slug, name_initials: profileData?.name_initials, language_iso_code: profileData?.language_iso_code});
                                        setLoaderStatus(false);
                                  })();

                    }
                  },[])


  if(isLoading)
  {
    return null;
  }

  return (
            <div className={`Sidebar ${Style.SidebarContainer} noprint`} style={{float: "left"}}>
                {/* ----------------------- Main Sidebar ----------------------- */}
                    <div className= {`MainSidebar ${Style.MainSidebar}`}>

                        {!commonAction.sidebarLogoUrl() && <div className={Style.MainSidebar__CompanyLogo}>
                          <Image src={CompanyImage} alt="Company-Logo"/>
                        </div>}
                        <div
                          className={`MainSidebar__Item ${Style.MainSidebar__Item} ${Style.MainSidebar__BackToHome}`}
                          onClick={() => {
                              let heartpaceUrl = REDIRECT.heartpace_url.replace('$client_doamin', session.subdomain || "app")
                              router.push(heartpaceUrl)
                          }}
                        >
                          <div
                            className={`IconContainer ${Style.MainSidebar__IconContainer}`}
                            style={{ margin: "0" }}
                          >
                            {setSidebarIcons("backToHome")}
                          </div>
                          <span
                            className={`${Style.MainSidebar__AvatarName}`}
                            style={{ marginTop: "0" }}
                          >
                            {t('back:main_menu')}
                          </span>
                        </div>

                        {/** Dummy Third Party Logo Image  **/}
                        {commonAction.sidebarLogoUrl() && <div className={`${Style.MainSidebar__ThirdPartyLogo}`}>
                          <img src={commonAction.sidebarLogoUrl()} alt="Third Party Logo"/>
                        </div>}
                        <div className={Style.MainSidebar__IconsAndAvatar}>
                          <ul className={Style.MainSidebar__CompanyItems}>

                            { Object.keys(options).map((key,index) => {

                              return (
                                        sidebarAction.show_sidebar_options(options, key, userRole, session) && <li   id  =   {key}
                                                                                                          key               =   {key}
                                                                                                          className         =   { props.pagekey == key ? options[key]['subSidebar_options'] != null && !sidebarAction.subsidebarNotAllowedForUrls(navbarStatus, options[key]['link']) ?  `MainSidebar__Item ${Style.MainSidebar__Item} Active Subsidebar`
                                                                                                                                                                                                                                                                                      :  `MainSidebar__Item ${Style.MainSidebar__Item} Active`
                                                                                                                                                       : `MainSidebar__Item ${Style.MainSidebar__Item}`}

                                                                                                          sidebar-present   =   { options[key]['sidebar_present'] }>

                                                                                                          <Tooltip className='SimpleTooltip' background={'#111128'} placement={'bottom'} fixed={false} offset={-12} radius={50} fontSize= "12px" padding={8} content={options[key]['title']} customCss={css`line-height: normal;`}>
                                                                                                              <div    className      =   {`IconContainer ${Style.MainSidebar__IconContainer}`}
                                                                                                                      data-tip       =   {key.replace(/(^\w{1})|(\s{1}\w{1})/g, match => match.toUpperCase())}
                                                                                                                      onClick        =   {(event) => {  setCurrentKeySelected(key) ;
                                                                                                                                                        sidebarAction.handleSidebarIconClick(event, options[key], router, updateNavbarStatus, navbarStatus, props.setPageKey, setFlagForRerender)}} >
                                                                                                                      { setSidebarIcons(key) }
                                                                                                              </div>

                                                                                                          </Tooltip>
                                                                                                          { key == 'communication' && currentKeySelected != 'communication' && props.countCommunication > 0 && <div className={'CommunicationCount'}>{props.countCommunication}</div> }
                                                                                                      </li>

                                     )}
                             )}

                          </ul>
                    </div>
                      { session?.role == userRole || (!session?.role && session.agency_user) ?
        <div className={Style.MainSidebar__LowerContainer}>
            <div
              className={`${Style.MainSidebar__Avatar}`}
              onClick={() => {
                router.push(sidebarAction.getProfileRoutes());
              }}
            >
              <img
                src={
                  user?.user_image != null || session?.photo_url != null
                    ? user?.user_image ||
                      session?.photo_url ||
                      COMMON.DUMMY_IMAGE
                    : COMMON.DUMMY_IMAGE
                }
                alt=""
                height={40}
                width={40}
                className={`AvatarImage ${Style.MainSidebar__AvatarImage} ${
                  imageExist(user, session) ? "" : "dnone"
                }`}
              />
              <p
                className={`AvatarInitials ${
                  imageExist(user, session) ? "dnone" : "d-flex"
                }`}
              >
                {user?.name_initials || session?.name_initials}
              </p>
              <span className={`AvatarName ${Style.MainSidebar__AvatarName}`}>
                {user?.user_name || session?.name}
              </span>
            </div>
          </div>
                                                            :
                                                              <div className= {`${Style.MainSidebar__Avatar}`} onClick={() => {sidebarAction.goToAdminDashboard(router)}}>
                                                                <ArrowLeft/>
                                                                <p className={`${Style.MainSidebar__BackToDashboardText}`}>Heartpace Dashboard</p>
                                                              </div>
                        }

                        <div className={Style.MainSidebar__TopRightCurveSection}>
                          <div className={Style.MainSidebar__TopRightCurve}></div>
                        </div>

                        <div className={Style.MainSidebar__BottomRightCurveSection}>
                           <div className={Style.MainSidebar__BottomRightCurve}></div>
                        </div>

                    </div>
                {/* ----------------------- Main Sidebar ----------------------- */}

                {/* ----------------------- Sub Sidebar ------------------------ */}
                    <SubSidebar pagekey              =  {props.pagekey}
                                setPageKey           =  {props.setPageKey}
                                userRole             =  {userRole}
                                currentRole          =  {session?.role}
                                setPath              =  {props.setPath}
                                path                 =  {props.path}
                                flagForRerender      =  {flagForRerender}
                               />
                {/* ----------------------- Sub Sidebar ------------------------- */}
            </div>
          )
}

function imageExist(user, session){
  return (user?.user_image != null || session?.photo_url != null)
}